import React, { Fragment, memo } from 'react';
//Componentes
import Botones from '../../../components/UI/botonera/headerBotones.js';
import CajaTexto from '../../../components/UI/cajaTexto/cajaTexto.jsx';
import TextArea from '../../../components/UI/textArea/textArea.jsx';

export function mantCorporacionesint(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.Titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>
                            <div className='row'>
                                <CajaTexto col="6" id="Id" type="text" label={props.Datos.Id.attributes.label} value={props.Datos.Id.value} attributes={props.Datos.Id.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Nombre" type="text" label={props.Datos.Nombre.attributes.label} value={props.Datos.Nombre.value} attributes={props.Datos.Nombre.attributes} onChangeInput={props.onChangeInput} />
                            </div>
                            <div className='row'>
                                <CajaTexto col="12" id="CedulaJuridica" type="text" label={props.Datos.CedulaJuridica.attributes.label} value={props.Datos.CedulaJuridica.value} attributes={props.Datos.CedulaJuridica.attributes} onChangeInput={props.onChangeInput} />
                            </div>                            
                            <div className='row'>
                                <CajaTexto col="6" id="Email" type="text" label={props.Datos.Email.attributes.label} value={props.Datos.Email.value} attributes={props.Datos.Email.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Site" type="text" label={props.Datos.Site.attributes.label} value={props.Datos.Site.value} attributes={props.Datos.Site.attributes} onChangeInput={props.onChangeInput} />
                            </div>
                            <div className='row'>
                                <CajaTexto col="6" id="Telefono" type="text" label={props.Datos.Telefono.attributes.label} value={props.Datos.Telefono.value} attributes={props.Datos.Telefono.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Fax" type="text" label={props.Datos.Fax.attributes.label} value={props.Datos.Fax.value} attributes={props.Datos.Fax.attributes} onChangeInput={props.onChangeInput}/>
                            </div>                            
                            <div className='row'>
                                <TextArea col="12" id="Direccion" type="text" label={props.Datos.Direccion.attributes.label} value={props.Datos.Direccion.value} attributes={props.Datos.Direccion.attributes} onChangeInput={props.onChangeInput} rows='3' />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};
export default memo(mantCorporacionesint);